import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useState} from 'react';
import { Divider } from "antd";
import axios from 'axios';
import {hooks} from '../../hooks';
import {items} from '../../items';
import {svg} from '../../assets/svg';
import {components} from '../../components';
import {URLS} from '../../config';


export const Profile: React.FC = () => {
  const navigate = useNavigate();
  const token = hooks.useAppSelector(state => state.auth.token);
  const [loading, setLoading] = useState<boolean>(true);
  const [profileData, setProfileData] = useState<any>([]);

  const getData = async () => {
    setLoading(true);
    try {
      const profile = await axios
        .get(URLS.GET_PROFILE, {
          headers: {
            Authorization: `JWT ${token}`,
          },
        })
        .then(res => res.data);
      setProfileData(profile);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='پروفایل من'
        burger={true}
        basket={true}
        line={true}
      />
    );
  };

  const renderUserInfo = (): JSX.Element => {
    return (
      <div className="bg-white overflow-hidden shadow rounded-lg border">
          <div className="px-4 py-5 sm:px-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                  پروفایل کاربری
              </h3>
              <Divider />
          </div>
         
          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
              <dl className="sm:divide-y sm:divide-gray-200">
              <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                        نام کاربری
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {profileData.username}
                      </dd>
                  </div>
                  <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                        نام و نام خانوادگی
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {profileData.first_name} {profileData.last_name}
                      </dd>
                  </div>
                  <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                          شماره تماس:
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {profileData.phone_number}
                      </dd>
                  </div>
                  <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                          ایمیل
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {profileData.email}
                      </dd>
                  </div>
                  <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                          آدرس
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                          {profileData.address1}
                          
                      </dd>
                  </div>
                  <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                          آدرس
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                          {profileData.address2}
                          
                      </dd>
                  </div>
              </dl>
          </div>
      </div>
        
    );
  };

  const renderMenu = (): JSX.Element => {
    return (
      <>
        <items.ProfileItem
          title='تاریخچه سفارشات'
          icon={<svg.CalendarSvg />}
          onClick={() => {
            navigate('/OrderHistory');
          }}
        />
        <items.ProfileItem
          title='کدهای تخفیف من'
          icon={<svg.GiftSvg />}
          onClick={() => {
            navigate('/MyPromocodes');
            // navigate('/MyPromocodesEmpty');
          }}
        />

        <items.ProfileItem
          title='خروج'
          icon={<svg.LogOutSvg />}
          onClick={() => {
            navigate('/SignOut');
          }}
          navIcon={false}
        />
      </>
    );
  };

  const renderContent = () => {
    return (
      <div style={{paddingTop: 40, paddingBottom: 64 + 30}}>
        {renderUserInfo()}
        {renderMenu()}
      </div>
    );
  };

  const renderBottomTabBar = () => {
    return <components.BottomTabBar />;
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};
